import { useFrame, useThree } from "@react-three/fiber";

import { useContextMenuStore } from "../../store/context-menu.store.js";

export const ContextMenuScreenBridge = () => {
  const { worldPosition, show, setScreenPosition } = useContextMenuStore();
  const { camera, gl } = useThree();

  useFrame(() => {
    if (!(show && worldPosition)) {
      return;
    }

    const projected = worldPosition.clone().project(camera);
    const canvas = gl.domElement;
    const rect = canvas.getBoundingClientRect();

    const x = ((projected.x + 1) / 2) * rect.width + rect.left;
    const y = ((-projected.y + 1) / 2) * rect.height + rect.top;
    const isVisible = projected.z < 1 && projected.z > -1;

    setScreenPosition({ isVisible, x, y });
  });

  return null;
};
